import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const fixImg = (url) => !url ? null : (url.startsWith('http') ? url : `${BACKEND}${url}`);

/**
 * DENSE — newspaper-style condensed list. Top image + up to 6 tight headline rows.
 * Inspired by wire-service layouts (AP / Reuters).
 */
export default function DenseBlock({ category, articles }) {
  if (!articles?.length) return null;
  const color = category?.color || '#dc2626';
  const [lead, ...rest] = articles.slice(0, 7);
  return (
    <div className="grid md:grid-cols-[1.15fr,1fr] gap-6" data-testid="dense-block">
      <Link to={`/clanak/${lead.slug}`} className="group block" data-testid="dense-lead">
        <div className="aspect-[4/3] rounded-lg overflow-hidden bg-gray-100 dark:deep-black-card mb-3">
          {fixImg(lead.cover_image_url) && (
            <img src={fixImg(lead.cover_image_url)} alt={lead.title_hr} loading="lazy"
                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          )}
        </div>
        <span className="inline-block text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm mb-2"
              style={{ backgroundColor: color }}>{category.name_hr}</span>
        <h3 className="text-xl font-black leading-[1.15] text-gray-900 dark:text-gray-50 group-hover:text-red-600 dark:group-hover:text-red-400 transition-colors">
          {lead.title_hr}
        </h3>
        {lead.excerpt_hr && <p className="mt-2 text-[14px] text-gray-600 dark:text-gray-400 line-clamp-2 leading-relaxed">{lead.excerpt_hr}</p>}
      </Link>
      <ul className="divide-y divide-gray-200 dark:divide-white/5" data-testid="dense-list">
        {rest.map((a, i) => (
          <li key={a.id}>
            <Link to={`/clanak/${a.slug}`} data-testid={`dense-row-${i}`}
                  className="group flex items-start gap-3 py-2.5">
              <span className="shrink-0 mt-1 w-5 text-[13px] font-black text-gray-300 dark:text-gray-600 tabular-nums">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="flex-1 text-[14px] font-bold leading-snug text-gray-900 dark:text-gray-100 group-hover:text-red-600 dark:group-hover:text-red-400 line-clamp-2 transition-colors">
                {a.title_hr}
              </span>
              <ArrowUpRight size={14} className="mt-1 shrink-0 text-gray-300 dark:text-gray-700 group-hover:text-red-600 dark:group-hover:text-red-400 transition-colors" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
